export const TAXONOMIES = ['analog_bjt', 'power_supply', 'single_mosfet', 'railldo'];

export const OPN_LIST = {
	ncv8730asnadjt1g: 'ncv8730asnadjt1g',
	ncv8730asn180t1g: 'ncv8730asn180t1g',
	ncv8730asn330t1g: 'ncv8730asn330t1g',
	ncv8730asn500t1g: 'ncv8730asn500t1g',
	ncv4294csn33t1g: 'ncv4294csn33t1g',
	ncv4294csn50t1g: 'ncv4294csn50t1g',
	ncv4295csn33t1g: 'ncv4295csn33t1g',
	ncv4295csn50t1g: 'ncv4295csn50t1g',
	ncv42962csn33t1g: 'ncv4296-2csn33t1g',
	ncv42962csn50t1g: 'ncv4296-2csn50t1g',
	ncv4274cst33t3g: 'ncv4274cst33t3g',
	ncv4274cst50t3g: 'ncv4274cst50t3g',
	ncp170amx180tbg: 'ncp170amx180tbg',
	ncp170amx330tbg: 'ncp170amx330tbg',
	ncp711asn300t1g: 'ncp711asn300t1g',
	ncp711asn330t1g: 'ncp711asn330t1g',
	ncp711asn500t1g: 'ncp711asn500t1g',
	ncp711asnadjt1g: 'ncp711asnadjt1g',
	ncv8187amt110tag: 'ncv8187amt110tag',
	ncv8187amtw110tag: 'ncv8187amtw110tag',
	ncv8187amt120tag: 'ncv8187amt120tag',
	ncv8187amt180tag: 'ncv8187amt180tag',
	ncv8187amtw180tag: 'ncv8187amtw180tag',
	ncv59745amw100tag: 'ncv59745amw100tag',
	ncp189cmtw120tag: 'ncp189cmtw120tag',
	ncp189cmtw180tag: 'ncp189cmtw180tag',
	ncp189cmtwadjtag: 'ncp189cmtwadjtag',
	ncp59801cmtwadjtag: 'ncp59801cmtwadjtag',
	ncp59801cmladjtcg: 'ncp59801cmladjtcg',
	railldo: 'railldo',
	nvbls0d8n08xtxg: 'nvbls0d8n08xtxg',
	ntbls0d8n08xtxg: 'ntbls0d8n08xtxg',
	ntmfws1d5n08xt1g: 'ntmfws1d5n08xt1g',
	nvmfws1d5n08xt1g: 'nvmfws1d5n08xt1g',
	nvnjws1k6n061ltag: 'nvnjws1k6n061ltag',
	nvnjws200n031ltag: 'nvnjws200n031ltag',
	nthl020n120sc1: 'nthl020n120sc1',
	nthl040n120sc1: 'nthl040n120sc1',
	nthl080n120sc1a: 'nthl080n120sc1a',
	nthl160n120sc1: 'nthl160n120sc1',
	nvhl020n120sc1: 'nvhl020n120sc1',
	nvhl040n120sc1: 'nvhl040n120sc1',
	nvhl080n120sc1a: 'nvhl080n120sc1a',
	nvhl160n120sc1: 'nvhl160n120sc1',
	ntbg020n120sc1: 'ntbg020n120sc1',
	ntbg028n170m1: 'ntbg028n170m1',
	ntbg040n120sc1: 'ntbg040n120sc1',
	ntbg080n120sc1: 'ntbg080n120sc1',
	ntbg160n120sc1: 'ntbg160n120sc1',
	nvbg020n120sc1: 'nvbg020n120sc1',
	nvbg040n120sc1: 'nvbg040n120sc1',
	nvbg080n120sc1: 'nvbg080n120sc1',
	nvbg160n120sc1: 'nvbg160n120sc1',
	nth4l020n120sc1: 'nth4l020n120sc1',
	nth4l028n170m1: 'nth4l028n170m1',
	nth4l040n120sc1: 'nth4l040n120sc1',
	nth4l080n120sc1: 'nth4l080n120sc1',
	nth4l160n120sc1: 'nth4l160n120sc1',
	nvh4l020n120sc1: 'nvh4l020n120sc1',
	nvh4l040n120sc1: 'nvh4l040n120sc1',
	nvh4l080n120sc1: 'nvh4l080n120sc1',
	nvh4l160n120sc1: 'nvh4l160n120sc1',
	nsvbcp53mtwg: 'nsvbcp53mtwg',
	nsvbcp5310mtwg: 'nsvbcp5310mtwg',
	nsvbcp5316mtwg: 'nsvbcp5316mtwg',
	bcp53mtwg: 'bcp53mtwg',
	bcp5310mtwg: 'bcp5310mtwg',
	bcp5316mtwg: 'bcp5316mtwg'
};

function importClass(opn) {
	for (let taxonomy of TAXONOMIES) {
		try {
			const module = require(`./definitions/${taxonomy}/${opn}`);
			if (module && module[opn]) {
				return module[opn];
			}
		} catch (e) {}
	}
	console.error(`Error: ${opn} not found in any taxonomy.`);
	return null;
}

export class LiveDatasheetDefinition {
	constructor(opn) {
		this.opn = opn.toLowerCase();
		const taxonomy = Object.keys(OPN_LIST).find(key => OPN_LIST[key] === this.opn);
		if (!taxonomy) {
			throw new Error(`OPN ${this.opn} is not defined in OPN_LIST`);
		}
		const PageDefinition = importClass(taxonomy);
		if (PageDefinition) {
			this.pageDefinition = new PageDefinition(this.opn);
		} else {
			throw new Error(`OPN ${this.opn} could not be imported`);
		}
	}
}
